

import Vue from 'vue'
import InfoIcon from '@/assets/svgs/info_icon.svg?inline'

export default Vue.extend({
  name: 'NavTooltip',
  components: {
    InfoIcon
  },
  props: {
    tooltipText: {
      type: String,
      required: false,
      default: '',
    },
    anchor: {
      type: String,
      required: false,
      default: 'bottom start',
    },
    self: {
      type: String,
      required: false,
      default: 'top start',
    },
    preserveSide: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Small tooltips have 1-2 lines of content and a 4px border radius
    // Large tooltips have 3+ lines of content and an 8px border radius
    smallTooltip: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
})
